import { Component, OnInit, Input } from '@angular/core';
import { DispatchBoardService } from '../../../../shared/services/dispatch-board.service';
import { GlobalsService } from '../../../../shared/services/globals.service';

@Component({
    selector: 'cp-tech-week',
    templateUrl: './tech-week.component.html',
    styleUrls: ['./tech-week.component.scss'],
    standalone: false
})
export class TechWeekComponent implements OnInit {

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService) { }

    //@Input() assignments: any[];
    @Input() techId: string;
    public weekCalendarCount: any = {
        sunday: 0,
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0
    };
    techAssignments: any;

    ngOnInit() {
        this.initData();
    }

    initData() {
        this.svc_data.getTechAssignments(this.techId).subscribe(data => {
            this.techAssignments = data;

            if (data.error) {
                alert('got an error back!');
            }
            this.setWeekCal(this.techAssignments ? this.techAssignments : []);
        });
        //this.setWeekCal(this.assignments ? this.assignments : []);
    }

    setWeekCal(assignments) {
        var currentTime = new Date();
        var sundays = this.findSunday(currentTime);
        for (var i = 0; i < assignments.length; i++) {
            let assignmentDate = new Date();
            assignmentDate = this.parseDate(assignments[i].startDate);
            if (assignmentDate > sundays[0] && assignmentDate < sundays[1]) {
                switch (assignmentDate.getDay()) {
                    case 0:
                        this.weekCalendarCount.sunday = this.weekCalendarCount.sunday + 1
                        break;
                    case 1:
                        this.weekCalendarCount.monday = this.weekCalendarCount.monday + 1;
                        break;
                    case 2:
                        this.weekCalendarCount.tuesday = this.weekCalendarCount.tuesday + 1
                        break;
                    case 3:
                        this.weekCalendarCount.wednesday = this.weekCalendarCount.wednesday + 1
                        break;
                    case 4:
                        this.weekCalendarCount.thursday = this.weekCalendarCount.thursday + 1
                        break;
                    case 5:
                        this.weekCalendarCount.friday = this.weekCalendarCount.friday + 1
                        break;
                    case 6:
                        this.weekCalendarCount.saturday = this.weekCalendarCount.saturday + 1
                        break;
                }
            }
        }
    }

    parseDate(date) {
        let Parts = date.split("T");
        let dateParts = Parts[0].split("-");
        let timeParts = Parts[1].split(":", 3);
        let parsedDate = new Date();
        parsedDate.setFullYear(dateParts[0]);
        parsedDate.setMonth(dateParts[1]);
        parsedDate.setDate(dateParts[2]);
        parsedDate.setHours(timeParts[0]);
        parsedDate.setMinutes(timeParts[1]);
        //parsedDate.setSeconds(timeParts[2]);
        return parsedDate;
    }

    findSunday(today: Date) {
        let sunday = new Date();
        switch (today.getDay()) {
            case 0:
                //nothing needed
                break;
            case 1:
                sunday.setDate(sunday.getDate() - 1);
                break;
            case 2:
                sunday.setDate(sunday.getDate() - 2);
                break;
            case 3:
                sunday.setDate(sunday.getDate() - 3);
                break;
            case 4:
                sunday.setDate(sunday.getDate() - 4);
                break;
            case 5:
                sunday.setDate(sunday.getDate() - 5);
                break;
            case 6:
                sunday.setDate(sunday.getDate() - 6);
                break;
        }
        let nextSunday = new Date();
        nextSunday.setDate(sunday.getDate() + 7);
        return [sunday, nextSunday];
    }

}
